import { useNavigate } from "react-router-dom";
import { ClientConfigurationContext } from "../../context/ClientConfigurationContextProvider";
import { useContext } from "react";
import { UserContext } from "../../context/UserContextProvider";

export default function AdminTabContent() {
    const navigate = useNavigate();
    const clientConfiguration = useContext(ClientConfigurationContext);
    const user = useContext(UserContext);

    return (
        <div className="col-sm-12 padding-top">
            {clientConfiguration.displayAgentTerminationRequest && user.authorizations?.canTerminateAgent && (
                <>
                    <button type="button" className="btn btn--primary" onClick={() => navigate("agent-termination")}>
                        Terminate an Agent
                    </button>
                    <br />
                </>
            )}
            {(clientConfiguration.displayAssignCompensationDelegate || (clientConfiguration.displayClientAlertEmailPreferences && user.authorizations?.canManageClientPreferences)) && (
                <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginBottom: "8px" }}>
                    {clientConfiguration.displayAssignCompensationDelegate && (
                        <button type="button" className="btn btn--primary" onClick={() => navigate("#")}>
                            Assign Delegate for Compensation Management
                        </button>
                    )}
                    {clientConfiguration.displayClientAlertEmailPreferences && user.authorizations?.canManageClientPreferences && (
                        <button type="button" className="btn btn--primary" onClick={() => navigate("/client-alert-email-preferences")}>
                            Client Alert Email Preferences
                        </button>
                    )}
                </div>
            )}
            {(clientConfiguration.displayAssignDelegateForOnboardingAgents || (clientConfiguration.displayManageBindingAuthority && user.authorizations?.canSetBindingAuthority)) && (
                <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginBottom: "8px" }}>
                    {clientConfiguration.displayAssignDelegateForOnboardingAgents && (
                        <button type="button" className="btn btn--primary" onClick={() => navigate("#")}>
                            Assign Delegate for Onboarding Agents
                        </button>
                    )}
                    {clientConfiguration.displayManageBindingAuthority && user.authorizations?.canSetBindingAuthority && (
                        <button type="button" className="btn btn--primary" onClick={() => navigate("/manage-binding-authority")}>
                            Manage Employee Binding Authority
                        </button>
                    )}
                </div>
            )}
            {clientConfiguration.displayResendOnboardingInvites && (
                <>
                    <button type="button" className="btn btn--primary" onClick={() => navigate("#")}>
                        Resend Onboarding Invite to Agents
                    </button>
                    <br />
                </>
            )}
        </div>
    );
}
